<template>
  <SideBarLeft />
  <SideBarRight />
  <main>
    <HeaderApp />
    <InitAuthentification>
      <RouterView />
    </InitAuthentification>
    <FooterApp />
  </main>
  <AppRegisterGlobals />
  <div
    v-environnement="{
      autorise: ['dev', 'staging', 'int', 'rec01', 'rec02'],
    }"
    class="envBox"
  >
    <BasicText
      weight="semibold"
      :label="currentEnv"
      color="red"
    />
  </div>
</template>

<script setup lang="ts">
  import SideBarLeft from '@/features/interface/layout/sideBar/left/SideBarLeft.vue'
  import SideBarRight from '@/features/interface/layout/sideBar/right/SideBarRight.vue'
  import HeaderApp from '@/features/interface/layout/header/HeaderApp.vue'
  import FooterApp from './features/interface/layout/footer/FooterApp.vue'
  import InitAuthentification from '@/features/auth/authentification/components/InitAuthentification.vue'
  import AppRegisterGlobals from './AppRegisterGlobals.vue'
  import type { Environnements } from './features/application/shared/Environnements.types'

  const currentEnv = import.meta.env.VITE_ENV as Environnements
</script>

<style scoped lang="less">
  @import '/src/assets/Mont/Mont.less';

  .envBox {
    right: 10px;
    bottom: 10px;
    position: absolute;
    padding: 12px;
    border: solid 2px red;
    border-radius: 8px;
  }

  main {
    background-color: @neutral-0;
    container-type: inline-size;
    display: flex;
    flex-direction: column;
    flex: 1;
    position: sticky;
    top: 0;
  }
</style>
